export default function sortLoads(data: any[]) {
  data = data.slice();
  const emptyLoadStopArray: any[] = data.filter((record: any) => {
    return record.loadStop && record.loadStop.length === 0;
  });
  const noLoadStopArray: any[] = data.filter((record: any) => {
    return !record.loadStop;
  });
  let loadStopArray: any[] = data.filter((record: any) => {
    return record.loadStop && record.loadStop.length > 0;
  });
  loadStopArray.sort((load1: any, load2: any) => {
    const loadA = sortedLoadStops(load1.loadStop);
    const loadB = sortedLoadStops(load2.loadStop);
    const loadAFromTime = getAppointmentTime(loadA[0]);
    const loadBFromTime = getAppointmentTime(loadB[0]);

    const shipmentId1: string = load1.shipmentId;
    const shipmentId2: string = load2.shipmentId;
    let shipmentSortValue = 0;
    shipmentSortValue = getShipmentSortValue(shipmentId1, shipmentId2, shipmentSortValue);

    if (loadAFromTime && loadBFromTime) {
      return shipmentSortData(loadAFromTime, loadBFromTime, shipmentSortValue);
    } else if (loadAFromTime && !loadBFromTime) {
      return -1;
    } else if (!loadAFromTime && loadBFromTime) {
      return 1;
    } else {
      return 1;
    }
  });
  if (emptyLoadStopArray.length > 0) {
    loadStopArray = loadStopArray.concat(emptyLoadStopArray);
  }
  if (noLoadStopArray.length > 0) {
    loadStopArray = loadStopArray.concat(noLoadStopArray);
  }
  return loadStopArray;
}

export const sortedLoadStops = (sortedLoadStops: any[]) =>
  sortedLoadStops.slice().sort((load1: any, load2: any) => {
    if (load1.sequenceNo && load2.sequenceNo) {
      return load1.sequenceNo - load2.sequenceNo;
    } else if (load1.stopSequence && load2.stopSequence) {
      return load1.stopSequence - load2.stopSequence;
    } else {
      return 0;
    }
  });

export const getAppointmentTime = (stop: any) => {
  let fromTime = '';
  if (stop.appointmentEarlyDateTime) {
    fromTime = stop.appointmentEarlyDateTime;
  } else if (stop.actualETADateTime) {
    fromTime = stop.actualETADateTime;
  } else if (stop.plannedEtaDateTime) {
    fromTime = stop.plannedEtaDateTime;
  }
  return fromTime;
};
function getShipmentSortValue(shipmentId1: string, shipmentId2: string, shipmentSortValue: number) {
  if (shipmentId1 < shipmentId2) {
    shipmentSortValue = -1;
  }
  if (shipmentId1 > shipmentId2) {
    shipmentSortValue = 1;
  }
  return shipmentSortValue;
}

function shipmentSortData(loadAFromTime: string, loadBFromTime: string, shipmentSortValue: number) {
  const dateLoadA = loadAFromTime;
  const dateLoadB = loadBFromTime;
  return dateLoadA > dateLoadB
    ? 1
    : dateLoadA < dateLoadB
      ? -1
      : shipmentSortValue;
}

